export default {
  state: {
    Code: 'ko',
  },
};
